// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__SAS71","consentsList":"PatientConsents_consentsList__2lNtk","consentsListEmpty":"PatientConsents_consentsListEmpty__2wD3m"};